import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import * as Api from '../../api/api';

export const deleteEmployeeGroup = (orgId: number, employeeGroupId: number) =>
  createGenericDispatcher<EmployeeGroup | null>({
    name: 'DELETE_EMPLOYEE_GROUP',
    loadFunction: () => Api.del(`/employee-groups/${employeeGroupId}?orgId=${orgId}`),
    args: { orgId, employeeGroupId },
  });
